import { Banner, Modal, Text, VerticalStack } from "@shopify/polaris";
import React, { useCallback, useState } from "react";

export interface ConfirmSellingPlanModalProps {
  open: boolean;
  planName: string;
  onClose: () => void;
  onConfirm: (sellingPlanId: number) => Promise<void>;
  selectedSellingPlanId: number;
  nextOrderDate: string | React.JSX.Element;
  isLoading: boolean;
}

export const ConfirmSellingPlanModal = ({
  open,
  planName,
  onClose,
  onConfirm,
  selectedSellingPlanId,
  nextOrderDate,
  isLoading,
}: ConfirmSellingPlanModalProps): JSX.Element => {
  const [isConfirming, setIsConfirming] = useState(false);

  const handleConfirm = useCallback(async () => {
    setIsConfirming(true);
    try {
      await onConfirm(selectedSellingPlanId);
    } finally {
      setIsConfirming(false);
    }
  }, [onConfirm, selectedSellingPlanId]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Confirm subscription plan change"
      primaryAction={{
        id: "subscription-details__confirm-selling-plan-btn",
        content: "Confirm",
        loading: isConfirming,
        onAction: handleConfirm,
        disabled: isLoading,
      }}
      secondaryActions={[
        {
          id: "subscription-details__cancel-selling-plan-btn",
          content: "Cancel",
          onAction: onClose,
          loading: isConfirming,
          disabled: isLoading,
        },
      ]}
      loading={isLoading}
    >
      <Modal.Section>
        <VerticalStack gap="4">
          <Text variant="bodyMd" as="p">
            Are you sure you want to change the subscription plan to <strong>{planName}</strong>?
          </Text>

          <Banner status="warning">
            <p>Next order date will be set to {nextOrderDate}.</p>
          </Banner>
        </VerticalStack>
      </Modal.Section>
    </Modal>
  );
};
